import { Layout } from '@app/layouts/auth';

export default Layout;
